module.exports = {"api_server":"https://service.56k.com.br/api/","api_base":"https://api.astandes.com.br/api/v1/","api_socket":"https://api.astandes.com.br","api_querotaxi":"https://cliente2.mpush.co","querotaxi_token":"9985aWFub2NvbXBhbnl1bmRlZmlu999="}


//////////////////
// WEBPACK FOOTER
// ./config.json
// module id = 104
// module chunks = 0